import AppTagStatus from '@nxsys/components/AppTagStatus';
import { TypedMessages } from '@nxsys/hooks/useTypedIntl';
import { Icons } from '@nxsys/types/icons';
import { formatStatus } from '@nxsys/utils';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';

export const getColumns = ({
  messages,
  handleViewDetail,
}: {
  messages: TypedMessages;
  isIreland: boolean;
  handleViewDetail: (id: string) => void;
  handleDelete?: (id: string) => void;
}): ColumnsType<IAgency> => {
  return [
    {
      key: 'action',
      title: messages['common.action'],
      fixed: 'left',
      align: 'left',
      render: (record) => (
        <ul className="flex items-center justify-start gap-x-2">
          <li onClick={() => handleViewDetail(record?.id)}>
            <Tooltip title="Edit">
              <span><Icons.IconEdit /></span>
            </Tooltip>
          </li>
          {record?.file && (
            <li onClick={() => window.open(record.file, '_blank')}>
              <Tooltip title="Download">
                <span><Icons.IconDownload /></span>
              </Tooltip>
            </li>
          )}
          {/* <li onClick={() => handleDelete?.(record?.id)}>
            <Tooltip title="Delete">
              <Icons.IconDelete />
            </Tooltip>
          </li> */}
        </ul>
      ),
      width: 100,
    },
    {
      key: 'status',
      title: messages['assignment.columns.status'],
      align: 'center',
      render: (record) => {
        const status = record?.status;
        return (
          <span className={`${formatStatus(status)}`}>
            <AppTagStatus className={`tag-popup ${formatStatus(status)}`}>
              {formatStatus(status)}
            </AppTagStatus>
          </span>
        );
      },
      width: 150,
    },
    {
      key: 'id',
      title: messages['table.agencyId'],
      dataIndex: 'id',
    },
    {
      key: 'name',
      title: messages['assignment.columns.agencyName'],
      dataIndex: 'name',
    },
    {
      key: 'contactName',
      title: messages['prospect.agency.columns.contactName'],
      dataIndex: 'contactName',
    },
    {
      key: 'email',
      title: messages['common.emailId'],
      dataIndex: 'email',
    },
  ];
};
